import { render, staticRenderFns } from "./SortTransfer.vue?vue&type=template&id=373258d8&"
import script from "./SortTransfer.vue?vue&type=script&lang=js&"
export * from "./SortTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports